import axios from '@/axios';

const RESOURCE_NAME = '/needs-startups';

export default {
    getStartups(id) {
        return axios.get(`${RESOURCE_NAME}/get-startups?id=${id}`)
    },

    getStartupDetails(linkId) {
        return axios.get(`${RESOURCE_NAME}/get-startup-details?link_id=${linkId}`)
    },

    setStartupMatchStatus(linkId, matchStatus) {
        return axios.post(`${RESOURCE_NAME}/set-startup-match-status?link_id=${linkId}`, {matchStatus})
    },

    toggleStartupStatus(linkId) {
        return axios.post(`${RESOURCE_NAME}/toggle-startup-status?link_id=${linkId}`)
    },

    saveStartupReview(linkId, data) {
        return axios.post(`${RESOURCE_NAME}/save-startup-review?link_id=${linkId}`, data)
    }
}
